/**
 * import and init global plugins
 */

import Vue from 'vue'

import globalEventBus from './globalEventBus'
import vuePortal from './VuePortal'
import vuelidate from './vuelidate'
import { VueSweetalert, swalOptions } from './sweetAlert'
import { vuelidateErrorExtractor, options } from './vuelidateErrorExtractor'
import { Storage, storageOptions } from './vueLS'
import VueOnlineProp from './online'
import './sentry'
import nonReactive from './nonReactive'

Vue.use(globalEventBus)
Vue.use(vuePortal)
Vue.use(vuelidate)
Vue.use(vuelidateErrorExtractor, options)
Vue.use(VueSweetalert, swalOptions)
Vue.use(Storage, storageOptions)
Vue.use(VueOnlineProp)
Vue.use(nonReactive)
